import * as _ from 'underscore';
import { ConnectionList } from './connectionList';
import { NewConnection } from './newConnection';
import { EditConnection } from './editConnection';
import { Templates } from '../../compile';
import { SectionView } from 'mappMvc/models/views';
import { IConnectionListItem } from 'mappClient/models';
import { ConnectionContentClient, ManagementClient } from 'mappClient/clients';
import { ViewOptions } from 'mappMvc/interfaces/options';
import { ID, Icons } from '../../const';
import { IView } from 'mappMvc/interfaces';
import { Localization } from 'mappMvc/compile';

export class ConnectionSection extends SectionView<IConnectionListItem> {
	private connectionList: ConnectionList;
	private newConnection: NewConnection;
	private editConnection: EditConnection;

	constructor(client: ConnectionContentClient | ManagementClient, options: ViewOptions) {
		super(
			_.defaults(options, <ViewOptions>{
				viewId: ID.ConnectionSection,
				label: Localization.Studio.Connection.Section,
				icon: Icons.ConnectionSection
			})
		);

		var views: IView[] = [];

		this.connectionList = new ConnectionList(client, { parent: this });
		views.push(this.connectionList);

		this.newConnection = new NewConnection(client, { parent: this });
		views.push(this.newConnection);

		this.editConnection = new EditConnection(client, { parent: this });
		views.push(this.editConnection);

		this.defaultView = this.connectionList;
		this.initViews(views);
	}

	public new() {
		window.router.navigateToView(this.newConnection);
	}

	public list() {
		window.router.navigateToView(this.connectionList);
	}
}
